// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"64716f2c","644":"0200ae0a"}[chunkId] + ".chunk.css";
};